import { FormattedMessage } from 'react-intl';

import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

export const NEW_MENU_CHIP: NavItemType['chip'] = {
  label: <FormattedMessage id="new" />,
  color: 'primary',
  variant: 'light',
  size: 'small'
};
